import { Icon, IconProps } from '@chakra-ui/react'

export const CardIcon = ({ ...props }: IconProps) => {
  return (
    <Icon viewBox="0 0 32 32" {...props}>
      <g clipPath="url(#clip0_632_21919)">
      <path
        d="M26.6667 5.33337H5.33334C3.85334 5.33337 2.68001 6.52004 2.68001 8.00004L2.66667 24C2.66667 25.48 3.85334 26.6667 5.33334 26.6667H26.6667C28.1467 26.6667 29.3333 25.48 29.3333 24V8.00004C29.3333 6.52004 28.1467 5.33337 26.6667 5.33337ZM25.3333 24H6.66667C5.93334 24 5.33334 23.4 5.33334 22.6667V16H26.6667V22.6667C26.6667 23.4 26.0667 24 25.3333 24ZM26.6667 10.6667H5.33334V9.33337C5.33334 8.60004 5.93334 8.00004 6.66667 8.00004H25.3333C26.0667 8.00004 26.6667 8.60004 26.6667 9.33337V10.6667Z"
        fill="currentColor"
      />
      </g>
      <defs>
      <clipPath id="clip0_632_21919">
      <rect width="32" height="32" fill="white"/>
      </clipPath>
      </defs>
    </Icon>
  )
}
